<template>
  <div>
    <div v-if="sheetIsActive && users.length" class="w-full bg-white rounded-md shadow">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <search-select-input
            id="select-user-input"
            ref="userInput"
            v-model="form.user_id"
            :options="users"
            :error="form.errors.user_id"
            :label="$t('keys.form.user_label')"
            value="id"
            text="name"
            :placeholder="$t('keys.form.user_placeholder')"
            class="pb-8 pr-6 w-full lg:w-1/3"
          />

          <search-multi-select-input
            id="select-key-input"
            ref="keyInput"
            v-model="form.keys"
            :options="keys"
            :error="form.errors.keys"
            :label="$t('keys.form.keys_label')"
            value="id"
            text="name"
            :custom-text="item => item.name"
            :placeholder="$t('keys.form.keys_placeholder')"
            class="pb-8 pr-6 w-full lg:w-2/3"
          />
        </div>

        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{ $t('keys.form.attach_keys') }}</loading-button>
        </div>
      </form>
    </div>
    <span v-else>
      {{ $t('keys.form.disabled', { formName: authUser?.sheet?.name ?? '' }) }}
    </span>
  </div>
</template>

<script>
// Components
import LoadingButton from '@/Shared/LoadingButton'
import SearchSelectInput from '@/Shared/SearchSelectInput'
import SearchMultiSelectInput from '@/Shared/SearchMultiSelectInput'

// Plugins
import Date from '@/Mixins/Date'

export default {
  components: {
    LoadingButton,
    SearchSelectInput,
    SearchMultiSelectInput,
  },
  mixins: [Date],
  props: {
    users: Array,
    keys: Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        user_id: null,
        keys: [],
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('keys.store'), {
        onSuccess: () => {
          this.form.reset()
          this.$refs.userInput.refreshSelected(this.form.user_id)
          this.$refs.keyInput.refreshSelected(this.form.keys)
        },
      })
    },
  },
}
</script>
